export default {
    introduce: "Copyright{'@'}"
}